<nav class="inm-bottom-nav" aria-label="Navegación principal">
  @for (tab of tabs; track tab.link) {
    <a
      class="inm-bottom-nav__tab"
      routerLinkActive="is-active"
      #tabLink="routerLinkActive"
      [routerLink]="tab.link"
      [routerLinkActiveOptions]="{ exact: tab.exact }"
      [attr.aria-current]="tabLink.isActive ? 'page' : null"
    >
      <i class="{{ tab.icon }}" aria-hidden="true"></i>
      <span>{{ tab.label }}</span>
    </a>
  }

  <button class="inm-bottom-nav__tab" type="button" (click)="openAccount()">
    <i class="inm-icon-person" aria-hidden="true"></i>
    <span>{{ user() ? 'Mi cuenta' : 'Ingresar' }}</span>
  </button>
</nav>

<app-bottom-sheet
  title="Tu viaje empieza aquí"
  description="Ingresa para guardar tus reservas y escribir reseñas."
  [(open)]="accountSheetOpen"
>
  @if (accountSheetOpen()) {
    <app-login-form
      [insideSheet]="true"
      (dismissed)="accountSheetOpen.set(false)"
      (registerRequested)="openMobileRegister(registerForm)"
    />
  }
</app-bottom-sheet>

<ng-template #registerForm let-modal>
  <app-register-form [modalRef]="modal" />
</ng-template>
